export interface ChannelConfig {
	targetOrigin: string;
	onReady?: () => void;
	onMessage?: (type: string, payload: unknown, version: number) => void;
	onError?: (error: Error) => void;
	onDisconnect?: () => void;
	onRouteChange?: (route: string) => void;
	timeout?: number;
}

export interface ControllerChannelConfig extends ChannelConfig {
	iframe: HTMLIFrameElement;
}

export interface ClientChannelConfig {
	hostOrigin: string;
	onReady?: () => void;
	onMessage?: (type: string, payload: unknown, version: number) => void;
	onError?: (error: Error) => void;
	onDisconnect?: () => void;
	timeout?: number;
}

export interface ChannelInstance {
	send: (type: string, payload: unknown, version?: number) => void;
	on: (type: string, callback: (payload: unknown, version: number) => void) => () => void;
	once: (type: string, callback: (payload: unknown, version: number) => void) => () => void;
	request: <T = unknown>(type: string, payload: unknown, timeoutMs?: number) => Promise<T>;
	reply: (requestId: string, data: unknown) => void;
	disconnect: () => void;
	reconnect: () => void;
	isConnected: () => boolean;
}

export interface BaseMessage {
	type: string;
	payload: unknown;
	version: number;
}

export enum HandshakeMessage {
	INIT = 'IFRAME_CHANNEL_INIT',
	RESPONSE = 'IFRAME_CHANNEL_RESPONSE',
	PORT = 'IFRAME_CHANNEL_PORT',
}

export const ROUTE_CHANGE = 'ROUTE_CHANGE';

export interface HandshakeEventData {
	message?: HandshakeMessage;
}
